export enum TabAnchor {
  PRODUCTS = '#products',
  CATEGORIES = '#categories',
  BRANDS = '#brands',
  STORES = '#stores',
}
